import { useLocation, useNavigate } from "react-router-dom";
import useAuthentication from "../../../hooks/useAuthentication";
import { useForm } from "react-hook-form";
import {
  initialFormData,
  MasterFormDataType,
  MasterTableDataType,
} from "./types";
import usePopup from "../../../hooks/usePopup";
import { useMutation } from "react-query";
import { saveMasterData } from "./services";
import { useEffect } from "react";
import {
  Paper,
  Typography,
  Button,
  CircularProgress,
  Divider,
} from "@mui/material";
import { CustomFormField } from "../../../utilis/component/CustomFormElement";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { RouteOfAdminType } from "../../../EMR/components/Prescription/types";
import { getRouteOfAdmin } from "../../../EMR/services";

const pageTitle = "Drug ";
function AddOrEditDrug() {
  const { user } = useAuthentication();
  const navigate = useNavigate();
  const { control, handleSubmit, reset } = useForm<MasterFormDataType>({
    defaultValues: initialFormData,
  });
  const {
    state: { data = null },
  } = useLocation() as { state: { data: MasterTableDataType } };
  const { showSnackbar } = usePopup();
  const handleGoBack = () => {
    navigate(-1);
  };

  const {
    mutate: fetchRouteOfAdmin,
    data: routeOfAdmin,
    isLoading: routeOfAdminLoading,
  } = useMutation(getRouteOfAdmin,);

  const { mutate: save, isLoading } = useMutation(saveMasterData, {
    onSuccess: (result) => {
      if (result.responseIndicator.toLowerCase() == "success") {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "success",
          duration: 3000,
        });
        handleGoBack();
      } else {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "warning",
          duration: 3000,
        });
      }
    },
    onError: (e: any) => {
      showSnackbar({
        message:
          e?.response?.data?.responseMessage ||
          e?.response?.data?.errorMessage ||
          "Something went wrong !",
        open: true,
        variant: "error",
        duration: 3000,
      });
    },
  });
  const onSubmit = (value: MasterFormDataType) => {
    save([{
      drugId: data ? data.drugId : 0,
      drugCode: value.drugCode,
      drugPackageName: value.drugPackageName,
      drugGenericName: value.drugGenericName,
      drugStrength: value.drugStrength,
      drugDosageForm: value.drugDosageForm,
      drugRoot: value.drugRoot?.routeName || "",
      drugStatus: value.drugStatus,
      isTablet: 0,
      drugUnit: "",
      createdByDate:"",
      drugAmount: Number(value.drugPrice),
      clinicId:Number(user?.clinicId),
      createdById: Number(user?.userId),
      drugPrice: Number(value.drugPrice),
      dosageUnitCode:value.dosageUnitCode || "",
      drugRatePackage:Number(value?.drugPackageRate || 0),
    }]);
  };

  const handleReset = () => {
    reset(initialFormData);
  };

  useEffect(() => {
    fetchRouteOfAdmin("")
    if (data) {
      reset({
        ...data,
        drugRoot:{
          routeId:0,
          routeName:data.drugRoot
        },

      });
    }
  }, [data]);

  return (
    <div className="p-3">
      <form onSubmit={handleSubmit(onSubmit)}>
        <Paper>
          <div className="flex justify-between items-center p-2">
            <div>
              <Typography variant="h6" className="p-3">
                {data ? "Update" : "Add"} {pageTitle}
              </Typography>
            </div>
            <div className="flex gap-2">
              <Button
                disabled={isLoading}
                variant="outlined"
                startIcon={<ArrowBackIcon />}
                onClick={handleGoBack}
              >
                back
              </Button>
              {!Boolean(data) && (
                <Button
                  disabled={isLoading}
                  color="error"
                  type="reset"
                  onClick={handleReset}
                  startIcon={<CloseIcon />}
                >
                  reset
                </Button>
              )}
              <Button
                disabled={isLoading}
                type="submit"
                color="success"
                startIcon={
                  isLoading ? (
                    <CircularProgress size={20} color="success" />
                  ) : (
                    <SaveIcon />
                  )
                }
              >
                {data ? "update" : "save"}
              </Button>
            </div>
          </div>
          <Divider />
            <div className="p-3 grid grid-cols-4 gap-3">
            <CustomFormField
              control={control}
              name="drugCode"
              element="input"
              fieldProps={{ label: "Enter drug code " }}
              rules={{ required: "Code is required" }}
            />
            <CustomFormField
              control={control}
              name="drugPackageName"
              element="input"
              fieldProps={{ label: "Enter package name " }}
              rules={{ required: "Name is required" }}
            />
             <CustomFormField
              control={control}
              name="drugPackageRate"
              element="input"
              fieldProps={{ label: "Enter drugPackage Rate " }}
              rules={{ required: "Rate is required" }}
            />
            <CustomFormField
              control={control}
              name="drugGenericName"
              element="input"
              fieldProps={{ label: "Enter generic code " }}
              rules={{ required: "Code is required" }}
            />
            <CustomFormField
              control={control}
              name="drugStrength"
              element="input"
              fieldProps={{ label: "Enter strength " }}
              rules={{ required: "Name is required" }}
            />
            <CustomFormField
              control={control}
              name="drugDosageForm"
              element="input"
              fieldProps={{ label: "Enter dosage form " }}
              rules={{ required: "Code is required" }}
            />
            <CustomFormField
              control={control}
              name="dosageUnitCode"
              element="input"
              fieldProps={{ label: "Enter dosage Code " }}
              rules={{ required: "Code is required" }}
            />
            <CustomFormField
              control={control}
              name="drugRoot"
              element="autocomplete"
              loading={routeOfAdminLoading}
              options={routeOfAdmin?.response || []}
              fieldProps={{ label: "Enter route of admin ", onChange: (e: any) => fetchRouteOfAdmin(e.target.value) }}
              autocompleteProps={{
              getOptionLabel: (option: RouteOfAdminType) => option.routeName || "",
              disableClearable: true,
              filterOptions: option => option
              }}
              rules={{ required: "Name is required" }}
            />
            <CustomFormField
              control={control}
              name="drugPrice"
              element="input"
              fieldProps={{
              label: "Enter price ",
              inputProps: { inputMode: "numeric", pattern: "^[0-9]*$" }
              }}
              rules={{
              required: "price  is required",
              pattern: {
                value: /^[0-9]*$/,
                message: "Only numbers are allowed"
              }
              }}
            />
            <CustomFormField
              control={control}
              name="drugStatus"
              element="radio"
              radioProps={{ row: true }}
              radios={[
              { label: "Active", value: 1 },
              { label: "Inactive", value: 0 },
              ]}
              fieldProps={{ label: "Status " }}
              rules={{ required: "Status is required" }}
            />
            </div>
        </Paper>
      </form>
    </div>
  );
  return <></>;
}

export default AddOrEditDrug;
